<template>
    <div class="row">
        <div class="col-md-8">
            <div class="row mb-4">
                <div class="col-md-4">
                    <div :class="currentStep == 1 ? 'step-title active' : 'step-title'">بارگذاری تصویر</div>
                </div>
                <div class="col-md-4">
                    <div :class="currentStep == 2 ? 'step-title active' : 'step-title'">تنظیمات متن</div>
                </div>
                <div class="col-md-4">
                    <div :class="currentStep == 3 ? 'step-title active' : 'step-title'">تعداد و مبلغ شارژ</div>
                </div>
                <div class="col-md-12 mt-4">
                    <div :style="{display: currentStep == 1 ? 'unset' : 'none'}">
                        <div class="row create-cart-box justify-content-center" v-if="imageSrc">
                            <div class="col-md-8 text-center">
                                <img id="image" :src="imageSrc">
                                <button class="btn btn-custom ml-1 mt-4 btn-dark" @click="changeImage">تغییر تصویر</button>
                                <button class="btn btn-primary btn-custom mt-4" @click="currentStep++">مرحله بعد</button>
                            </div>
                        </div>
                        <div class="row justify-content-center text-center" v-else>
                            <p class="w-100 mb-2">تصویر مورد نظر خود را انتخاب کنید</p>
                            <div class="mt-3 mb-2">
                                <label for="custom-file-upload" class="filupp">
                                    <span class="filupp-file-name js-value">انتخاب تصویر</span>
                                    <input type="file" name="attachment-file" value="1" id="custom-file-upload" @change="setImage" accept="image/png,image/jpeg">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="currentStep == 2">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="custom-label">متن مورد نظر خود را وارد کنید</label>
                                    <input type="text" class="form-control" v-model="cardText" v-on:keyup="cardTextChecker" :readonly="imageUrl != ''">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="margin-bottom:8px;display: block;width: 100%">انتخاب فونت</label>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <button :class="`btn btn-dark btn-block ${fontName != 'IRANSans' ? 'opacity-75' : ''}`" @click="fontName = 'IRANSans'">ایران سنس</button>
                                        </div>
                                        <div class="col-md-4">
                                            <button :class="`btn btn-dark btn-block ${fontName != 'Titr' ? 'opacity-75' : ''}`" @click="fontName = 'Titr'">تیتر</button>
                                        </div>
                                        <div class="col-md-4">
                                            <button :class="`btn btn-dark btn-block ${fontName != 'IranNastaliq' ? 'opacity-75' : ''}`" @click="fontName = 'IranNastaliq'">نستعلیق</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="custom-label">سایز متن</label>
                                    <VueSlider v-model="fontSize" :min="12" :max="42" :interval="2" :tooltip="'always'" :disabled="imageUrl != ''" />
                                </div>
                                <div class="form-group mt-4">
                                    <label class="custom-label">رنگ متن</label>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <button class="text-color-button color-button red" :disabled="imageUrl != ''" @click="e => setTextColor('red',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="text-color-button color-button blue" :disabled="imageUrl != ''" @click="e => setTextColor('blue',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="text-color-button color-button orange" :disabled="imageUrl != ''" @click="e => setTextColor('orange',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="text-color-button color-button green" :disabled="imageUrl != ''" @click="e => setTextColor('green',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="text-color-button color-button black" :disabled="imageUrl != ''" @click="e => setTextColor('black',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <Verte picker="square" :model="'hex'" v-model="textColor" @input="setTextColor" v-if="imageUrl == ''">
                                                <button class="color-button" :style="{background: textColor}">دلخواه</button>
                                            </Verte>
                                            <button class="color-button" :style="{background: textColor}" v-else disabled>دلخواه</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="custom-label">سایز سایه</label>
                                    <VueSlider v-model="borderSize" :max="5" :tooltip="'always'" :disabled="imageUrl != ''" />
                                </div>
                                <div class="form-group mt-4">
                                    <label class="custom-label">رنگ سایه</label>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <button class="stork-color-button color-button red" :disabled="imageUrl != ''" @click="e => setBorderColor('red',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="stork-color-button color-button blue" :disabled="imageUrl != ''" @click="e => setBorderColor('blue',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="stork-color-button color-button orange" :disabled="imageUrl != ''" @click="e => setBorderColor('orange',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="stork-color-button color-button green" :disabled="imageUrl != ''" @click="e => setBorderColor('green',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <button class="stork-color-button color-button black" :disabled="imageUrl != ''" @click="e => setBorderColor('black',e)"></button>
                                        </div>
                                        <div class="col-md-2">
                                            <Verte picker="square" :model="'hex'" v-model="borderColor" @input="setBorderColor" v-if="imageUrl == ''">
                                                <button class="color-button" :style="{background: borderColor}">دلخواه</button>
                                            </Verte>
                                            <button class="color-button" :style="{background: borderColor}" v-else disabled>دلخواه</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary btn-custom wizard-button ml-1 mt-4" @click="currentStep--">مرحله قبل</button>
                                <button class="btn btn-primary btn-custom wizard-button ml-1 mt-4" @click="currentStep++">مرحله بعد</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="currentStep == 3">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row justify-content-center">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>انتخاب مبلغ شارژ</label>
                                            <select class="form-control mb-3" v-model="depositId">
                                                <option value="41">بدون شارژ</option>
                                                <option value="61">مبلغ دلخواه</option>
                                                <option v-for="(deposit,index) in depositsList" :key="index" :value="deposit.depositId">{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(deposit.depositValue) }} ریال</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="depositId == 61">
                                        <div class="form-group">
                                            <label>مبلغ دلخواه (ریال)</label>
                                            <input type="tel" class="form-control ltr-input" v-model="optionalCredit" @keyup="e => changeCustomDepositValue(e)" @change="handleMinAndMax">
                                        </div>
                                    </div>
                                    <div class="col-md-4 pl-0">
                                        <div class="form-group">
                                            <label>تعداد</label>
                                            <input type="number" min="0" max="10000" class="form-control ltr-input" placeholder="تعداد" value="0" v-model="itemsCount" @keyup="e => itemsCount = parseInt(itemsCount)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary btn-custom wizard-button ml-1 mt-1" v-if="imageSrc != ''" @click="currentStep--">مرحله قبل</button>
                                <button class="btn btn-success btn-custom wizard-button mt-1" :disabled="disableButton || (itemsCount && itemsCount < 1)" @click="saveImage" v-if="imageSrc != ''">تایید و افزودن به سبد</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <h6 class="custom-card-box-title">پیش نمایش</h6>
            <hr class="mb-4">
            <div id="preview-parent">
                <div id="preview-container" class="mt-3">
                    <img src="/assets/img/giftcard.png" class="card-template">
                    <div class="card-text-area">
                        <DragItDude>
                            <div id="inner-element" :style="`cursor: pointer;font-size: 35px;font-family: ${fontName}`">{{ cardText }}</div>
                        </DragItDude>
                    </div>
                    <div id="preview"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import DragItDude from 'vue-drag-it-dude';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import Verte from 'verte';
import 'verte/dist/verte.css';
import html2canvas from 'html2canvas';

export default {
    name: 'CustomCard',
    props: ['addToCard','depositsList'],
    components: {VueSlider,Verte,DragItDude},
    data(){
        return {
            cardType: 3,
            imageSrc: '',
            imageUrl: '',
            customText: '',
            depositId: 0,
            optionalCredit: '',
            itemsCount: 0,
            textColor: 'rgb(244, 244, 244)',
            borderColor: 'rgb(244, 244, 244)',
            fontSize: 14,
            fontName: 'IRANSansFa',
            borderSize: 0,
            disableButton: false,
            cardText: '',
            price: 0,
            currentStep: 1
        }
    },
    watch: {
        fontSize(value){
            document.getElementById('inner-element').style.fontSize = (value * 2.5) + 'px';
        },
        borderSize(value){
            document.getElementById('inner-element').style.webkitTextStrokeWidth = value + 'px';
        }
    },
    methods: {
        setImage(e){
            let reader = new FileReader();
            reader.onload = e => {
                this.imageSrc = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        cardTextChecker(){
            this.cardText = this.cardText.replace(/[0-9]/g,'');
        },
        changeImage(){
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        },
        handleMinAndMax(e){
            let value = parseInt(e.target.value.toString().replace(/,/g,'')) || 0;
            if(value < 200000){
                this.$swal({
                    icon: 'error',
                    title: 'خطا',
                    text: 'کمترین مبلغ شارژ 200,000 ریال می باشد'
                });
                e.target.value = '';
            }
        },
        changeCustomDepositValue(e){
            let value = this.optionalCredit ? this.optionalCredit.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 20000000)
                value = 20000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.optionalCredit = value;
        },
        setTextColor(color,e = null){
            let buttons = document.querySelectorAll('.text-color-button');
            for(let button in buttons)
                if(typeof buttons[button] == 'object')
                    buttons[button].classList.remove('active');
            if(e != null && typeof e == 'object')
                e.target.classList.add('active');
            document.getElementById('inner-element').style.color = color;
            this.textColor = color;
        },
        setBorderColor(color,e = null){
            let buttons = document.querySelectorAll('.stork-color-button');
            for(let button in buttons)
                if(typeof buttons[button] == 'object')
                    buttons[button].classList.remove('active');
            if(e != null && typeof e == 'object')
                e.target.classList.add('active');
            document.getElementById('inner-element').style.webkitTextStrokeColor = color;
            this.borderColor = color;
        },
        async saveImage(){
            this.disableButton = true;
            document.getElementById('preview-container').style.transform = 'unset';
            html2canvas(document.getElementById('preview-container')).then(canvas => {
                this.imageUrl = canvas.toDataURL('image/png');
            });
            document.getElementById('preview-container').style.transform = 'scale(0.32)';
            await html2canvas(document.getElementById('preview-container')).then(canvas => {
                let base64Data = canvas.toDataURL('image/png').replace('data:image/png;base64,','');
                this.minifyImageUrl = 'data:image/png;base64,' + base64Data;
            });
            let metaData = [
                {
                    key: 2,
                    base64: this.imageUrl
                },
                {
                    key: 3,
                    base64: this.cardText
                },
                {
                    key: 105,
                    base64: this.textColor
                },
                {
                    key: 106,
                    base64: this.borderColor
                },
                {
                    key: 107,
                    base64: this.fontName
                }
            ];
            this.addToCard(0,'کارت هدیه فیزیکی دلخواه',this.cardType,this.itemsCount,this.price,this.minifyImageUrl,this.depositId,this.optionalCredit,metaData);
            this.disableButton = false;
            this.currentStep = 1;
            this.depositId = 0;
            this.optionalCredit = '';
            this.itemsCount = 0;
            this.imageSrc = '';
            this.cardText = '';
            this.imageUrl = '';
            this.textColor = 'rgb(244, 244, 244)';
            this.borderColor = 'rgb(244, 244, 244)';
            this.fontSize = 14;
            this.borderSize = 0;
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        }
    },
    created(){
        this.$api.get('Config/CustomCost').then(({data}) => {
            this.price = parseInt(data.result);
        });
    }
}
</script>